<template>
	<div class="xs-12 bg5 b1 bc7 p4 r2">
		<div class="xs-12 flex">
			<!-- Issue Proposal -->
			<j-button
				v-if="!isProposalIssued"
				size="small"
				:isLoading="isIssueProposalLoading"
				@click="$modal.show('issueProposal')"
			>
				Issue Proposal
			</j-button>
			<!-- Create Policy -->
			<j-button
				class="ml2"
				size="small"
				:isLoading="isCreatePoliciesLoading"
				@click="createPolicies"
			>
				Create Policy
			</j-button>

			<!-- Download PDF -->
			<j-button
				class="ml2"
				size="small"
				:isLoading="isDownloadLoading"
				@click="downloadPdf"
			>
				Download Quote PDF
			</j-button>
		</div>

		<!-- Modal -->
		<core-modal name="issueProposal" headline="Issue Proposal">
			<div class="p4">
				<berkley-actions-issue-proposal @done="afterIssue" />
			</div>
		</core-modal>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import api from "@/api/gql.js"
import CoreModal from "@/modules/core/components/CoreModal"

import BerkleyActionsIssueProposal from "./BerkleyActionsIssueProposal"

import { gql } from "@/api/utils.js"

export default {
	components: { JButton, CoreModal, BerkleyActionsIssueProposal },

	data() {
		return {
			isIssueProposalLoading: false,
			isCreatePoliciesLoading: false,
			isDownloadLoading: false
		}
	},

	methods: {
		async createPolicies() {
			const query = gql`
				mutation generatePoliciesFromProposal(
					$caseId: String!
					$proposalId: String!
				) {
					generatePoliciesFromProposal(
						caseId: $caseId
						proposalId: $proposalId
					) {
						status
						errors
					}
				}
			`

			this.isCreatePoliciesLoading = true
			const res = await api({
				query,
				variables: {
					caseId: this.$store.state.caseManagement.caseId,
					proposalId: this.$store.state.caseManagement.proposalId
				}
			})
			this.isCreatePoliciesLoading = false

			// Errors
			if (res?.data?.generatePoliciesFromProposal?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.generatePoliciesFromProposal?.errors?.[0] ||
						this.$t("errors.general")
				)
				return
			}

			// Show success message
			this.$store.dispatch("addMessage", {
				delay: "5000",
				message: {
					type: "success",
					text: "Yay, policy was successfully created!"
				}
			})
		},

		async downloadPdf() {
			// Decide if it is PDF file or HTML PDF
			let apiKey = "renderPdfDrawingTemplate"
			const templateId = "4a8b41bb-32fa-406f-9107-dbe7994218c8"

			// Query
			const query = gql`
				query getQuoteTemplate(
					$templateId: String!
					$input: templateRenderParametersInput
				) {
					renderPdfDrawingTemplate(templateId: $templateId, input: $input) {
						errors
						status
						value
					}
				}
			`

			// Currency options
			// Get currency form contract currency which is a case.fact.currency
			const contractCurrency = this.$store.state.caseManagement?.case?.facts?.find(
				fact => fact.type === "currency"
			)?.value?.stringValue

			const currencyOptions = contractCurrency
				? { currencyCodes: [contractCurrency] }
				: { currencyCodes: [] }

			// Variables
			const { caseId, proposalId, offerId } = this.$store.state.caseManagement
			const variables = {
				templateId,
				input: {
					name: "data",
					variablesJsonString: JSON.stringify({
						caseWhere1: { id: caseId },
						proposalWhere1: { id: proposalId },
						offerWhere1: { id: offerId },
						currencyOptions
					})
				}
			}

			// Based on if valuesJson or content Json was selected, send proper data
			if (this.type === "variables")
				variables.input.variablesJsonString = this.variablesJson

			// Call
			this.isDownloadLoading = true
			const res = await api({ query, variables })
			this.isDownloadLoading = false

			// Errors
			if (res?.data?.[apiKey]?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.[apiKey]?.errors?.[0] || [this.$t("errors.general")]
				)
				return
			}

			// Download file
			let bytes = new Uint8Array(res.data?.[apiKey]?.value) // pass your byte response to this constructor
			let blob = new Blob([bytes], { type: "application/pdf" }) // change resultByte to bytes
			let link = document.createElement("a")
			link.href = window.URL.createObjectURL(blob)
			link.download = `Insurance Quote - Combined General Liability Public & Products.pdf`
			link.click()
		},

		afterIssue() {
			this.$modal.hide("issueProposal")
			this.$emit("proposal:issued")
		}
	},

	computed: {
		isProposalIssued() {
			return this.$store.state.caseManagement.proposals?.[0]?.isIssued
		}
	}
}
</script>
